import { useAppDispatch, useAppSelector } from 'modules/hooks/appHooks';
import { Inbox, PageWithHeader } from 'modules/ui';
import { StyledPagination } from 'modules/ui/table/styled';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { InboxSelectors, InboxThunks } from '../../redux';
import { InboxSize } from '../helper';

export const InboxPage: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const [searchInput, setSearchInput] = useState<string>();
  const [currentPage, setCurrentPage] = useState<number>(1);

  const messages = useAppSelector(InboxSelectors.selectMessages);
  const totalPages = useAppSelector(InboxSelectors.selectTotalPageCount);

  useEffect(() => {
    dispatch(
      InboxThunks.fetchInboxMessages({
        page: 1,
        size: InboxSize,
      }),
    );
    setSearchInput('');
  }, [dispatch]);

  const fetchMoreInboxMessages = useCallback(
    (page: number) => {
      dispatch(
        InboxThunks.fetchInboxMessages({
          page,
          size: InboxSize,
          search: searchInput,
        }),
      );
      setCurrentPage(page);
    },
    [dispatch, searchInput],
  );

  const handleMessageOpen = useCallback(
    async (id: number) => {
      dispatch(InboxThunks.markInboxMessageAsRead(id));
    },
    [dispatch],
  );

  const handleMessageSearch = useCallback(
    (search?: string) => {
      dispatch(
        InboxThunks.fetchInboxMessages({
          page: currentPage,
          size: InboxSize,
          search,
        }),
      );
      setSearchInput(search);
    },
    [dispatch, currentPage],
  );

  return (
    <PageWithHeader
      title={t('inboxPage.title')}
      description={t('inboxPage.description')}>
      <Inbox
        messages={messages}
        handleMessageOpen={handleMessageOpen}
        handleMessageSearch={handleMessageSearch}
      />
      {totalPages !== undefined && totalPages > 0 && (
        <StyledPagination
          maxPages={totalPages}
          currentPage={currentPage}
          onPageChange={fetchMoreInboxMessages}
        />
      )}
    </PageWithHeader>
  );
};
